import { ILoyaltyServiceUserFragment, ILoyaltyUserFragment } from 'generated/graphql-gateway';

import { LoyaltyUser } from './types';

export const mapLegacyLoyaltyUser = (user?: ILoyaltyUserFragment | null): LoyaltyUser => {
  if (user == null) {
    return user;
  }

  return {
    id: String(user.id),
    name: user.name,
    points: user.points,
    rewardRedemptionLimit: user.rewardRedemptionLimit,
    metadata: user.metadata?.map(value => (value ? { key: value.key, value: value.value } : null)),
    pointsExpiryDateKey: user.pointsExpiryDateKey,
    offerRedemptionAvailability: user.offerRedemptionAvailability
      ? {
          availableAfter: user.offerRedemptionAvailability.availableAfter,
          isCooldownActive: user.offerRedemptionAvailability.isCooldownActive,
        }
      : user.offerRedemptionAvailability,
    rewardRedemptionAvailability: user.rewardRedemptionAvailability
      ? {
          availableAfter: user.rewardRedemptionAvailability.availableAfter,
          isCooldownActive: user.rewardRedemptionAvailability.isCooldownActive,
        }
      : user.rewardRedemptionAvailability,
    secondaryIdentifiers: user.secondaryIdentifiers?.map(value =>
      value
        ? {
            identifier: value.identifier,
            identifierType: value.identifierType,
          }
        : null
    ),
    expirationBuckets: user.expirationBuckets?.map(value => ({
      expirationDate: value.expirationDate,
      pointsToExpire: value.pointsToExpire,
    })),
    idPay: user.idPay
      ? {
          enabled: user.idPay.enabled,
          storedPaymentMethodId: user.idPay.storedPaymentMethodId,
        }
      : user.idPay,
    partnerUserData: user.partnerUserData?.map(value => ({
      createdAt: value.createdAt,
      updatedAt: value.updatedAt,
      id: value.id,
      name: value.name,
      partner: value.partner,
      partnerData: value.partnerData
        ? {
            status: value.partnerData.status,
            userState: value.partnerData.userState,
          }
        : value.partnerData,
      partnerUserId: value.partnerUserId,
      status: value.status,
    })),
  };
};

export const mapServiceLoyaltyUser = (user?: ILoyaltyServiceUserFragment | null): LoyaltyUser => {
  if (user == null) {
    return user;
  }

  return {
    id: user.id,
    name: user.name,
    points: user.points,
    rewardRedemptionLimit: user.rewardRedemptionLimit,
    metadata: user.metadata?.map(value => (value ? { key: value.key, value: value.value } : null)),
    pointsExpiryDateKey: user.pointsExpiryDateKey,
    offerRedemptionAvailability: user.offerRedemptionAvailability
      ? {
          availableAfter: user.offerRedemptionAvailability.availableAfter,
          isCooldownActive: user.offerRedemptionAvailability.isCooldownActive,
        }
      : user.offerRedemptionAvailability,
    rewardRedemptionAvailability: user.rewardRedemptionAvailability
      ? {
          availableAfter: user.rewardRedemptionAvailability.availableAfter,
          isCooldownActive: user.rewardRedemptionAvailability.isCooldownActive,
        }
      : user.rewardRedemptionAvailability,
    secondaryIdentifiers: user.secondaryIdentifiers?.map(value => ({
      identifier: value.identifier,
      identifierType: value.identifierType,
    })),
    expirationBuckets: user.expirationBuckets?.map(value => ({
      expirationDate: value.expirationDate,
      pointsToExpire: value.pointsToExpire,
    })),
    idPay: user.idPay
      ? {
          enabled: user.idPay.enabled,
          forterDeviceId: user.idPay.forterDeviceId,
          forterTokenCookie: user.idPay.forterTokenCookie,
          storedPaymentMethodId: user.idPay.storedPaymentMethodId,
        }
      : user.idPay,
    partnerUserData: user.partnerUserData?.map(value => ({
      createdAt: value.createdAt,
      updatedAt: value.updatedAt,
      id: value.id,
      name: value.name,
      partner: value.partner,
      partnerData: value.partnerData
        ? {
            status: value.partnerData.status,
            userState: value.partnerData.userState,
          }
        : value.partnerData,
      partnerUserId: value.partnerUserId,
      status: value.status,
    })),
  };
};
